import styled from 'styled-components';
import { color, font, displaySoft, label, space, maxWidth, bp, ease } from '../../styles/tokens';
import { CONFIG } from '../../consts/prices';

export const Bar = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 50;
  padding: 12px ${space.gutter};
  background: rgba(32, 26, 30, 0.86);
  backdrop-filter: saturate(1.4) blur(14px);
  border-bottom: 1px solid ${color.lineDark};
  opacity: ${(p) => (p.$stuck ? 1 : 0)};
  transform: translateY(${(p) => (p.$stuck ? '0' : '-100%')});
  pointer-events: ${(p) => (p.$stuck ? 'auto' : 'none')};
  transition: opacity 0.4s ${ease}, transform 0.4s ${ease};
`;

export const Inner = styled.div`
  max-width: ${maxWidth};
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  /* Keeps the nav clear of the fixed language toggle when it's turned on. */
  padding-right: ${CONFIG.mostrarSeletorDeIdioma ? '104px' : '0'};
`;

export const Mark = styled.a`
  ${displaySoft};
  font-style: italic;
  font-size: 22px;
  color: ${color.white};

  span {
    ${label};
    font-style: normal;
    font-size: 9px;
    letter-spacing: 0.35em;
    color: ${color.rose};
    margin-left: 2px;
  }
`;

export const Nav = styled.nav`
  display: none;
  gap: 30px;

  ${bp.sm} {
    display: flex;
  }

  a {
    ${label};
    font-family: ${font.body};
    color: rgba(240, 220, 222, 0.7);
    transition: color 0.3s ${ease};

    &:hover {
      color: ${color.rose};
    }
  }
`;
